module.exports = __webpack_public_path__ + "img/discount16.61560ef6.png";